import { render, staticRenderFns } from "./Wordpress.vue?vue&type=template&id=f026b9b6&scoped=true&"
import script from "./Wordpress.vue?vue&type=script&lang=js&"
export * from "./Wordpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f026b9b6",
  null
  
)

export default component.exports